import { FormProps } from "antd";

export const defaultPropsForm: FormProps = {
  layout: "vertical",
  requiredMark: false,
};
